import React, { useEffect, useState } from 'react';
import { getIdTargetOnThisPage, parseContentHTML } from 'helpers/string';
import { cloneDeep, isArray } from 'lodash';
import classNames from 'classnames';
import Timer from 'helpers/setTimer';
import { Link, animateScroll as scroll } from 'react-scroll';
import 'react-quill/dist/quill.snow.css';

const timerDetectId = new Timer();
const Content = ({ dataGuideLine }) => {
  const [contentSelected, setContent] = useState({});
  const [listOnThisPage, setListOnThisPage] = useState([]);

  //! Effect
  useEffect(() => {
    if (isArray(dataGuideLine) && dataGuideLine.length > 0) {
      setContent(dataGuideLine[0]);
    }
  }, [dataGuideLine]);

  // Detect id and text for OnThisPage
  useEffect(() => {
    const listId = getIdTargetOnThisPage(contentSelected.content || '');
    timerDetectId.debounce(() => {
      let tempArr = [];
      (listId || []).forEach((id) => {
        tempArr = [
          ...tempArr,
          {
            id,
            text: document.querySelector(id)?.textContent,
          },
        ];
      });

      setListOnThisPage(tempArr);
    }, 0);
  }, [contentSelected]);

  const onClickMenu = (item) => (e) => {
    e.stopPropagation();
    scroll.scrollToTop();
    setContent(item);
  };

  //! Render
  return (
    <div className='content-container ql-snow'>
      <div className='left'>
        <div className='left__menu'>
          <span className='title'>Features</span>
          <div className='list-page'>
            {isArray(dataGuideLine) &&
              cloneDeep(dataGuideLine)
                .sort((val1, val2) => val1.order - val2.order)
                .map((el) => (
                  <div
                    key={el.id}
                    className={classNames('each-page', {
                      'is-active': el.id === contentSelected.id,
                    })}
                    onClick={onClickMenu(el)}
                  >
                    {el.title}
                  </div>
                ))}
          </div>
        </div>
      </div>

      <div
        className='center ql-editor'
        dangerouslySetInnerHTML={{
          __html: parseContentHTML(contentSelected.content),
        }}
      />

      <div className='right'>
        <div className='right__on-this-page'>
          <span className='title'>On this page</span>
          <div className='list-item'>
            {listOnThisPage.map((ele) => (
              <Link
                key={ele.id}
                className='item'
                to={ele.id?.replace('#', '')}
                spy={true}
                offset={-100}
                smooth={true}
              >
                {ele.text}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
